module.exports = __webpack_public_path__ + "static/media/20170806_29day_1460AT.29ac1b1d.jpg";